import type {
  GEOLOCATION_ACTION,
  GeolocationPermissionStatus
} from '$constants/enums';

export interface GeolocationState {
  position: GeolocationPosition | null;
  error: GeolocationError | null;
  lastUpdated: Date | null;
  permissionStatus: GeolocationPermissionStatus;
}

export interface GeolocationPosition {
  coordinates: {
    latitude: number;
    longitude: number;
    accuracy: number;
    altitude?: number | null;
    altitudeAccuracy?: number | null;
    heading?: number | null;
    speed?: number | null;
  };
  timestamp: number;
}

export interface GeolocationError {
  code: number;
  message: string;
}

export type GeolocationAction =
  | {
      type: typeof GEOLOCATION_ACTION.SET_GEOLOCATION_LOADING;
      payload: boolean;
    }
  | {
      type: typeof GEOLOCATION_ACTION.SET_GEOLOCATION_POSITION;
      payload: GeolocationPosition;
    }
  | {
      type: typeof GEOLOCATION_ACTION.SET_GEOLOCATION_ERROR;
      payload: GeolocationError;
    }
  | {
      type: typeof GEOLOCATION_ACTION.SET_GEOLOCATION_PERMISSION;
      payload: GeolocationPermissionStatus;
    }
  | { type: typeof GEOLOCATION_ACTION.CLEAR_GEOLOCATION_ERROR };

export const geolocationInitial: GeolocationState = {
  position: null,
  error: null,
  lastUpdated: null,
  permissionStatus: null
};
